import React, { useState, useEffect } from 'react';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import { FaSave, FaUpload, FaTrash, FaSpinner, FaCheckCircle, FaGlobe } from 'react-icons/fa';

const WebContentManage = () => {
  const [pageName, setPageName] = useState('Introduction');
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [newsCount, setNewsCount] = useState(1);
  const [eventCount, setEventCount] = useState(1);
  const [videoCount, setVideoCount] = useState(1);
  useEffect(() => {
    fetchPageData();
  }, [pageName]);

  const fetchPageData = async () => {
    try {
      const res = await API.get(`get-content/${pageName}/`);
      setContent(res.data);
      
      if (pageName === 'NewsList') {
        let count = 1;
        while (res.data[`news${count + 1}_title`]) count++;
        setNewsCount(count);
      }
      if (pageName === 'Events') {
        let count = 1;
        while (res.data[`event${count + 1}_title`]) count++;
        setEventCount(count);
      }
      if (pageName === 'Videos') {
        let count = 1;
        while (res.data[`video${count + 1}_title`]) count++;
        setVideoCount(count);
      }

    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const handleUpdate = async (key, value = null, file = null) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('page_name', pageName);
    formData.append('section_key', key);
    if (file) formData.append('media_file', file);
    else if (value) formData.append('content_text', value);

    try {
      await API.post('update-content/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setUploadStatus(key);
      setTimeout(() => setUploadStatus(''), 2000);
      fetchPageData();
    } catch (err) {
      toast.error('Upload Failed! Check your backend.');
    } finally {
      setLoading(false);
    }
  };

  const allFields = {

    'Home Gallery': [
      { key: 'gallery_1', label: 'Gallery Image 1 (Top Left)' },
      { key: 'gallery_2', label: 'Gallery Image 2 (Top Right)' },
      { key: 'gallery_3', label: 'Gallery Image 3 (Bottom Left)' },
      { key: 'gallery_4', label: 'Gallery Image 4 (Bottom Right)' },
    ],
    'Introduction': [
      { key: 'intro_building', label: 'Main Introduction Image' },
      { key: 'buddha_img', label: 'Ambassador Section Image' },
      { key: 'certificate_img', label: 'Record Certificate Image' },
      { key: 'youtube_link', label: 'YouTube Video Link' },
      { key: 'youtube_title', label: 'YouTube Section Title' },
      { key: 'youtube_caption', label: 'YouTube Section Caption' },
      { key: 'gallery_1', label: 'Gallery Image 1' },
      { key: 'gallery_2', label: 'Gallery Image 2' },
      { key: 'gallery_3', label: 'Gallery Image 3' },
      { key: 'gallery_4', label: 'Gallery Image 4' },
      { key: 'gallery_5', label: 'Gallery Image 5' },
      { key: 'gallery_6', label: 'Gallery Image 6' }
    ],
    'Mission Vision': [
      { key: 'mission_text', label: 'Mission Text' },
      { key: 'vision_text', label: 'Vision Text' },
      { key: 'gallery_1', label: 'Gallery Image 1' },
      { key: 'gallery_2', label: 'Gallery Image 2' },
      { key: 'gallery_3', label: 'Gallery Image 3' },
      { key: 'gallery_4', label: 'Gallery Image 4' },
      { key: 'gallery_5', label: 'Gallery Image 5' },
      { key: 'gallery_6', label: 'Gallery Image 6' }
    ],
    'Founder': [
      { key: 'founder_image', label: 'Founder Profile Image' }
    ],
    'Awards': [
      ...Array.from({ length: 4 }).flatMap((_, i) => [
        { key: `award_${i + 1}_title`, label: `Award ${i + 1} - Title` },
        { key: `award_${i + 1}_org`, label: `Award ${i + 1} - Organization` },
        { key: `award_${i + 1}_desc`, label: `Award ${i + 1} - Description` },
        { key: `award_${i + 1}_badge`, label: `Award ${i + 1} - Badge` },
        { key: `award_${i + 1}_img`, label: `Award ${i + 1} - Image` },
      ]),
      { key: 'video_title', label: 'Video Section Title' },
      { key: 'video_caption', label: 'Video Section Caption' },
      { key: 'youtube_link', label: 'YouTube Video Link' }
    ],
    'Mudra': [
      { key: 'mudra_main_img', label: 'Main Mudra Image (Upload)' },
      { key: 'healing_percent', label: 'Healing Percentage' },
      { key: 'healing_label', label: 'Healing Label' },
      { key: 'title', label: 'Main Title' },
      { key: 'subtitle', label: 'Subtitle' },
      { key: 'p1', label: 'Paragraph 1' },
      { key: 'p2', label: 'Paragraph 2' },
      { key: 'quote', label: 'Quote' },
      ...Array.from({ length: 4 }).map((_, i) => ({ key: `benefit_${i + 1}`, label: `Benefit ${i + 1}` })),
      { key: 'curriculum_title', label: 'Curriculum Section Title' },
      { key: 'curriculum_subtitle', label: 'Curriculum Subtitle' },
      ...Array.from({ length: 8 }).map((_, i) => ({ key: `course_step_${i + 1}`, label: `Course Step ${i + 1}` })),
      { key: 'curriculum_note', label: 'Curriculum Note' }
    ],
    'Motivational Lectures': [
      { key: 'main_heading', label: 'Main Heading' },
      { key: 'sub_heading', label: 'Sub Heading' },
      ...Array.from({ length: 8 }).map((_, i) => ({ key: `topic_${i + 1}`, label: `Motivational Topic ${i + 1}` }))
    ],
    'Happiness Index Corporate': [
      { key: 'intro_statement', label: 'Intro Statement' },
      { key: 'sub_intro', label: 'Sub-Intro Text' },
      ...Array.from({ length: 10 }).map((_, i) => ({ key: `q_${i + 1}`, label: `Corporate Question ${i + 1}` })),
      { key: 'closing_p1', label: 'Closing Paragraph 1' },
      { key: 'closing_p2', label: 'Closing Paragraph 2' },
      { key: 'closing_p3', label: 'Closing Paragraph 3' }
    ],
    'Books': [
      { key: 'book1_img', label: 'Book 1 Cover Image' },
      { key: 'book1_title', label: 'Book 1 Title' },
      { key: 'book1_author', label: 'Book 1 Author' },
      { key: 'book1_pillars_title', label: 'Pillars Title' },
      ...['A','B','C','D'].map(char => ({ key: `book1_pillar_${char}`, label: `Pillar ${char}` })),
      { key: 'book2_img', label: 'Book 2 Cover Image' },
      { key: 'book2_title', label: 'Book 2 Title' }
    ],
    'NewsList': [
      ...Array.from({ length: 10 }).flatMap((_, i) => [
        { key: `news${i + 1}_title`, label: `News ${i + 1} Title` },
        { key: `news${i + 1}_desc`, label: `News ${i + 1} Description` },
        { key: `news${i + 1}_url`, label: `News ${i + 1} URL` },
        { key: `news${i + 1}_source`, label: `News ${i + 1} Source` },
        { key: `news${i + 1}_img`, label: `News ${i + 1} Image` }
      ])
    ],
    'Dawadi Center': [
      ...Array.from({ length: 6 }).flatMap((_, i) => [
        { key: `dawadi_${i + 1}_title`, label: `Section ${i + 1} Title` },
        { key: `dawadi_${i + 1}_text`, label: `Section ${i + 1} Text` },
        { key: `dawadi_${i + 1}_img`, label: `Section ${i + 1} Image` }
      ])
    ],
    'Events': [
      ...Array.from({ length: 10 }).flatMap((_, i) => [
        { key: `event${i + 1}_title`, label: `Event ${i + 1} Title` },
        { key: `event${i + 1}_date`, label: `Event ${i + 1} Date` },
        { key: `event${i + 1}_location`, label: `Event ${i + 1} Location` },
        { key: `event${i + 1}_desc`, label: `Event ${i + 1} Description` },
        { key: `event${i + 1}_img`, label: `Event ${i + 1} Image` }
      ])
    ],
    
    
  };

  return (
    <div
    className="
    bg-gray-100
    min-h-screen
    p-3
    sm:p-4
    md:p-8
    "
    >
      <div
      className="
      max-w-5xl
      mx-auto
      w-full
      "
      >
        <div className="
        bg-white
        rounded-2xl
        shadow-xl
        border-t-8
        border-[#032167]
        mb-5
        p-4
        sm:p-5
        md:p-6
        ">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <FaGlobe className="text-[#032167]" /> Website Content Manager
          </h2>
          <select 
            className="
            w-full
            rounded-xl
            border-2
            border-gray-200
            p-3
            md:p-4
            text-sm
            md:text-lg
            outline-none
            focus:border-[#032167]
            "
            value={pageName}
            onChange={(e) => { setPageName(e.target.value); setContent({}); }}
          >
            {Object.keys(allFields).map(p => <option key={p} value={p}>{p} Page</option>)}
            
            {/* <option value="Introduction">Introduction Page</option>
            <option value="Mission Vision">Mission Vision Page</option>
            <option value="Founder">Founder Page</option>
            <option value="Awards">Awards Page</option>
            <option value="Mudra">Mudra Page</option>
            <option value="Motivational Lectures">Motivational Lectures</option>
            <option value="Happiness Index Corporate">Happiness Index Corporate</option>
            
            <option value="Books">Books</option>
            <option value="NewsList">NewsList</option> */}

          </select>
        </div>

        <div className="space-y-4">
          {pageName === 'NewsList' ? (
              <>
                {Array.from({ length: newsCount }).map((_, i) => (
                 
                  <div key={`news-${i}-${content[`news${i + 1}_title`] || 'new'}`} className="
                  bg-white
                  rounded-xl
                  shadow-sm
                  border-l-4
                  border-[#032167]
                  p-4
                  md:p-6
                  ">
                    <h3 className="font-bold text-lg mb-4 text-[#032167]">News {i + 1}</h3>
                    {['title', 'desc', 'url'].map(field => (
                      <input 
                        key={`news-${i}-${field}`} 
                        placeholder={field.toUpperCase()} 
                       
                        defaultValue={content[`news${i + 1}_${field}`] || ''} 
                        onBlur={(e) => handleUpdate(`news${i + 1}_${field}`, e.target.value)} 
                        className="
                        w-full
                        border
                        rounded-lg
                        p-3
                        text-sm
                        mb-3
                        "
                      />
                    ))}
                    <div className="text-[11px] break-all text-gray-400 mt-1">Current: {content[`news${i + 1}_img`] || "No image"}</div>
                    <input type="file" onChange={(e) => handleUpdate(`news${i + 1}_img`, null, e.target.files[0])} className="w-full mt-3 text-sm" />
                  </div>
                ))}
                <button onClick={() => setNewsCount(newsCount + 1)} className="
                w-full
                bg-[#032167]
                text-white
                rounded-xl
                py-3
                font-bold
                text-sm
                hover:bg-blue-900
                transition
                ">+ Add New News</button>
              </>
            ) : pageName === 'Events' ? (
              <>
                {Array.from({ length: eventCount }).map((_, i) => (
                  
                  <div key={`event-${i}-${content[`event${i + 1}_title`] || 'new'}`} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#032167] mb-4">
                    <h3 className="font-bold text-lg mb-4 text-[#032167]">Event {i + 1}</h3>
                    {['title', 'date', 'location', 'desc'].map(field => (
                      <input 
                        key={`event-${i}-${field}`} 
                        placeholder={field.toUpperCase()} 
                        defaultValue={content[`event${i + 1}_${field}`] || ''} 
                        onBlur={(e) => handleUpdate(`event${i + 1}_${field}`, e.target.value)} 
                        className="w-full p-2 border mb-2 rounded" 
                      />
                    ))}
                    <div className="text-xs text-gray-400 mt-1">Current: {content[`event${i + 1}_img`] || "No image"}</div>
                    <input type="file" onChange={(e) => handleUpdate(`event${i + 1}_img`, null, e.target.files[0])} className="w-full mt-2" />
                  </div>
                ))}
                <button onClick={() => setEventCount(eventCount + 1)} className="bg-[#032167] text-white px-6 py-3 rounded-lg font-bold w-full">+ Add New Event</button>
              </>
            ) : pageName === 'feedbackVideos' ? (
              <div className="space-y-4">
                {Array.from({ length: videoCount }).map((_, i) => (
                  
                  <div key={`video-${i}`} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#032167]">
                    <h3 className="font-bold text-lg mb-4 text-[#032167]">Video {i + 1}</h3>
                    
                    
                    <>
                        <input 
                          placeholder="VIDEO TITLE" 
                          defaultValue={content[`video${i + 1}_title`] || ''} 
                          onBlur={(e) => handleUpdate(`video${i + 1}_title`, e.target.value)} 
                          className="w-full p-2 border mb-2 rounded" 
                        />
                        
                        <textarea 
                          placeholder="DESCRIPTION" 
                          defaultValue={content[`video${i + 1}_desc`] || ''} 
                          onBlur={(e) => handleUpdate(`video${i + 1}_desc`, e.target.value)} 
                          className="w-full p-2 border mb-2 rounded" 
                        />
                        
                        <input 
                          placeholder="YOUTUBE LINK OR ID" 
                          defaultValue={content[`video${i + 1}_link`] || ''} 
                          onBlur={(e) => handleUpdate(`video${i + 1}_link`, e.target.value)} 
                          className="w-full p-2 border mb-2 rounded font-mono" 
                        />
                    </>
                  </div>
                ))}
                
                <button 
                  onClick={() => setVideoCount(videoCount + 1)} 
                  className="bg-[#032167] text-white px-6 py-3 rounded-lg font-bold w-full hover:bg-[#54a50f] transition"
                >
                  + Add New Video
                </button>
              </div>
            ) : (
            (allFields[pageName] || []).map((field) => (
              <div key={field.key} className="
              bg-white
              rounded-xl
              shadow-sm
              p-4
              flex
              flex-col
              md:flex-row
              md:items-center
              md:justify-between
              gap-4
              ">
                <div>
                  <p className="text-xs font-bold text-blue-600 uppercase">{field.key}</p>
                  <p className="font-semibold break-words">{field.label}</p>
                </div>
                <div
                className="
                flex
                flex-col
                sm:flex-row
                items-stretch
                sm:items-center
                gap-3
                w-full
                md:w-auto
                "
                >
                  <input type="text" className="
                  w-full
                  md:w-56
                  border
                  rounded-lg
                  p-3
                  text-sm
                  " defaultValue={content[field.key] || ''} onBlur={(e) => handleUpdate(field.key, e.target.value)} />
                  <label className="
                  cursor-pointer
                  bg-gray-100
                  rounded-lg
                  w-full
                  sm:w-12
                  h-12
                  flex
                  items-center
                  justify-center
                  hover:bg-blue-100
                  "><FaUpload /><input type="file" className="hidden" onChange={(e) => handleUpdate(field.key, null, e.target.files[0])} /></label>
                </div>
              </div>
            ))
          )}
         
        </div>
      </div>
    </div>
  );
};
export default WebContentManage;